import { Box } from '@chakra-ui/react'
import { useEffect } from 'react'
import { pdfjs } from 'react-pdf'
import HandlePackageJsonVersion from './components/general/HandlePackageJsonVersion'
import MfSweetAlert from './components/general/MfSweetAlert'
import useEE from './components/hooks/easterEgg'
import useFeaturebase from './hooks/useFeaturebase'
import useSession from './hooks/useSession'
import MFRouter from './router/MFRouter'
import 'react-toastify/dist/ReactToastify.css'
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

HandlePackageJsonVersion()

const App = () => {
  useEE()
  const { handleAdminValidation, checkStorageToken } = useSession()
  useFeaturebase()

  useEffect(() => {
    checkStorageToken()
  }, [checkStorageToken])

  useEffect(() => {
    handleAdminValidation()
  }, [handleAdminValidation])

  return (
    <Box h="100%">
      {/* <MFFeaturebaseSdk /> */}
      <MfSweetAlert />
      <MFRouter />
    </Box>
  )
}

export default App
